<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="title"><img alt="image" src="images/3_img01.jpg"/></p>
<p class="title1">by<br/>GINU KAMANI</p>
<p class="title2"><i><b>aunt lute books</b></i></p>
<p class="title3"><span class="small">SAN FRANCISCO</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?29640854